import SockJS from 'sockjs-client'
import util from '../libs/util'

const webSocketUrl = 'ws://' + util.wsBaseUrl + '/websocket'
const sockJSUrl = 'http://' + util.wsBaseUrl + '/sockjs/websocket'
const channels = {}
let MAX_RECONNECT_TIMES = 50 // 重连的最大尝试次数
let socketReconnectTimes = 0 // 当前重连次数
let retryWaitTimes = [1, 2, 3, 5, 10, 15, 20, 30, 40, 60] // 重试时间间隔，单位秒
let webSocket

function createWebSocket() {
  if ('WebSocket' in window) {
    webSocket = new WebSocket(webSocketUrl + '?access_token=' + util.token())
  } else {
    webSocket = new SockJS(sockJSUrl + '?access_token=' + util.token())
  }
  webSocket.onopen = () => {
    socketReconnectTimes = 0 // 连接成功，重连次数归0
    heartCheck.reset().start() // 心跳检测重置并开始
  }
  webSocket.onclose = () => {
    reconnect()
  }
  webSocket.onerror = (e) => {
    console.error('初始化WebSocket失败')
    console.error(e)
  }
  webSocket.onmessage = (e) => {
    heartCheck.reset().start() // 如果获取到任何消息，连接正常，心跳检测重置
    let result = JSON.parse(e.data)
    if (result.type === 'ping') {
      return
    }
    let channel = result.type
    ws.notifyObservers(channel, result)
  }
}

function reconnect() {
  // 连续失败超过最大次数
  if (socketReconnectTimes >= MAX_RECONNECT_TIMES) {
    return
  }
  socketReconnectTimes++
  if (socketReconnectTimes > 1) {
    // 设置延迟避免频繁请求
    var waitIndex = socketReconnectTimes
    if (socketReconnectTimes > retryWaitTimes.length) {
      waitIndex = retryWaitTimes.length
    }
    var waitTime = retryWaitTimes[waitIndex - 1]
    // console.log("waitTime:" + waitTime);
    setTimeout(function () {
      // console.log("reconnect");
      createWebSocket()
    }, waitTime * 1000)
  } else {
    // 首次重连直接请求
    createWebSocket()
  }
}

let heartCheck = {
  timeout: 5000, // 5秒发一次心跳
  timeoutObj: null,
  reset: function () {
    clearTimeout(this.timeoutObj)
    return this
  },
  start: function () {
    this.timeoutObj = setTimeout(function () {
      // 这里发送一个心跳，后端收到后，返回一个心跳消息，
      // onmessage拿到返回的心跳就说明连接正常
      webSocket.send('ping')
      // console.log("ping");
    }, this.timeout)
  }
}

// window.onbeforeunload = function () {
//   if (webSocket) {
//     webSocket.close()
//   }
// }

const ws = {
  init() {
    createWebSocket()
  },
  registerObserver(channel, observer) {
    if (!channels[channel]) {
      channels[channel] = []
    }
    let channelObservers = channels[channel]
    let isExist = false
    for (let i = 0; i < channelObservers.length; i++) {
      if (channelObservers[i] === observer) {
        isExist = true
        break
      }
    }
    if (!isExist) {
      channels[channel].push(observer)
    }
  },
  removeObserver(channel, observer) {
    let channelObservers = channels[channel]
    if (channelObservers && channelObservers.length > 0) {
      let i = channelObservers.length
      while (i--) {
        if (channelObservers[i] === observer) {
          channelObservers.splice(i, 1)
          break
        }
      }
    }
  },
  notifyObservers(channel, message) {
    let channelObservers = channels[channel]
    if (channelObservers && channelObservers.length > 0) {
      channelObservers.forEach((observer) => {
        if (observer.onMessage) {
          observer.onMessage(message)
        }
      })
    }
  }
}

export default ws



// WEBPACK FOOTER //
// ./src/websocket/index.js